<ion-item [button]="button" [detail]="detail" [lines]="lines" (click)="onItemClick()">
  <ion-label>
    <h2>{{ boardName }}</h2>
  </ion-label>
  <ng-content select="[slot=end]"></ng-content>
</ion-item>
